module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-226.5f72485.woff2";